/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ThListIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "th-list", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 5.5, y: 6.5, width: 14, height: 12, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 6.5V18.5M19.5 10.5H5.5M19.5 14.5H5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ThListIcon);
export default ForwardRef;
//# sourceMappingURL=thListIcon.js.map